<template>
    <div class="login_con">
        <nav-bar :navigationIndex="null" bgColor="#047E41" />
        <div style="height:125px"></div>
        <div class="flex_around">
            <div class="login_main">
                <div class="login_box">
                    <div class="login_title flex">
                        <div class="title_left flex_column">
                            <span>忘记密码</span>
                            <!-- <div class="login_line"></div> -->
                            <span class="title-content">万源市农村产权(茶园)流转交易服务平台</span>
                        </div>
                        <!-- <div class="title_right">
                            | Login
                        </div> -->
                    </div>
                    <div class="login_input flex">
                        <el-icon color="#00AC64" style="font-size: 19px">
                            <Avatar />
                        </el-icon>
                        <input placeholder="请输入手机号" v-model.trim="formState.phone" type="text" />
                    </div>
                    <div class="login_input flex" style="align-items: center;">
                        <el-icon color="#00AC64" style="font-size: 19px">
                            <Finished />
                        </el-icon>
                        <input placeholder="请输入验证码" v-model.trim="formState.code" type="text" />
                        <button class="get-code" @click="handleCode">{{ countdownText }}</button>
                    </div>
                    <div class="login_input flex">
                        <el-icon color="#00AC64" style="font-size: 19px">
                            <Lock />
                        </el-icon>
                        <input placeholder="请输入密码" v-model.trim="formState.newPassword"
                            :type="isPasswordVisible ? 'text' : 'password'" />
                        <el-icon class="cursor" style="font-size: 22px;" @click="viewPass(false)"
                            v-if="isPasswordVisible">
                            <Hide />
                        </el-icon>
                        <el-icon class="cursor" style="font-size: 22px;" @click="viewPass(true)" v-else>
                            <View />
                        </el-icon>
                    </div>

                    <div class="login_btn">
                        <button @click="getReset()">重置密码</button>
                    </div>
                    <div class="cursor" @click="goPage('/loginPage')">
                        <div>已有帐户？去登录</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { updatePwdCode, sendMsg } from "@/utils/api";
// @ is an alias to /src

export default {
    components: {
    },
    data() {
        return {
            formState: {
                phone: '',
                newPassword: '',
                code: ""

            },
            rules: {
                phone: [
                    { required: true, message: "请输入手机号", trigger: "blur" },
                ],
                newPassword: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    { min: 6, max: 12, message: "长度在 6 到 12 个字符", trigger: "blur" }
                ],
                userType: [
                    { required: true, message: "请选择用户类型", trigger: "change" },
                ],
            },
            pageNum: 1,
            countdown: 60,
            countdownText: "获取验证码",
            isCountdown: false,
            isSend: false,
            isPasswordVisible: false,
        }
    },
    mounted() {
    },
    methods: {
        // 查看密码
        viewPass(isPassword) {
            // console.log(isPassword);
            this.isPasswordVisible = isPassword;
        },
        handleCode() {
            if (this.formState.phone == '' || this.formState.phone == null) {
                this.$message.error('手机号不能为空');
                return;
            }
            if (this.isCountdown) {
                return;
            }
            sendMsg({ phone: this.formState.phone }).then((res) => {
                if (res.code == 200) {
                    this.$message.success("发送成功");
                    this.isSend = true;
                    this.countdown = 60;
                    this.countdownText = "获取验证码";
                    this.isCountdown = true;
                    let timer = setInterval(() => {
                        if (this.countdown > 0) {
                            this.countdown--;
                            this.countdownText = this.countdown + "s";
                        } else {
                            this.isCountdown = false;
                            this.countdownText = "获取验证码";
                            clearInterval(timer);
                        }
                    }, 1000);
                }
            })
        },
        handleChangeType(type) {
            if (this.pageNum == 2) {
                return;
            }
            this.formState.userType = type
        },
        // 下一页
        nextPage() {
            if (!this.formState.phone || !this.formState.newPassword || !this.formState.userType) {
                this.$message.error("请填写必填项");
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.formState.phone)) {
                this.$message.error("手机号码有误，请重填");
                return;
            }
            this.pageNum = 2
        },
        lastPage() {
            this.pageNum = 1
        },
        getReset() {
            if (this.formState.phone == '' || this.formState.phone == null) {
                this.$message.error('手机号不能为空');
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.formState.phone)) {
                this.$message.error("手机号码有误，请重填");
                return;
            }
            if (this.formState.newPassword == '' || this.formState.newPassword == null) {
                this.$message.error('请输入密码');
                return;
            }
            if (this.formState.code == '' || this.formState.code == null) {
                this.$message.error('请输入验证码');
                return;
            }
            updatePwdCode(this.formState).then((res) => {
                if (res.code == 200) {
                    this.$message.success("重置成功");
                    this.goPage("/loginPage");
                } else {
                    this.$message.error(res.msg);
                }
            });

        },
        goPage(path) {
            this.$router.push({
                path: path
            });
        }
    }
}
</script>

<style scoped lang="scss">
.login_con {
    height: 100vh;
    background: url("@/assets/images/regBg.png") no-repeat center;
    background-size: 100% 100%;
}

.login_main {
    position: fixed;
    top: 53%;
    left: 75%;
    transform: translate(-50%, -50%);
    width: 420px;
    background-color: #fff;
    // box-shadow: 0 0 16px 2px rgba(19, 128, 56, .6);
    border-radius: 11px;
}

.login_box {
    padding: 70px 30px 30px 30px;
}

.login_title {
    font-size: 40px;
    color: #00AC64;
    margin-bottom: 20px;
    line-height: 50px;
    font-family: SOURCEHANSANSCN-BOLD;
    display: flex;
    align-items: baseline;
}

.login_line {
    width: 90px;
    height: 2px;
    background: #00AC64;
    border-radius: 2px;
    margin-top: 3px;
}

.title_right {
    font-size: 21px;
    font-weight: 400;
    color: #626262;
    margin-left: 5px;
    margin-bottom: 10px;

}

.title_left {
    display: flex;
    justify-content: start;
}

.title_center {
    font-size: 21px;
    font-weight: 400;
    color: #626262;
    margin-left: 5px;
    margin-bottom: 10px;
}

.login_btn button {
    width: 100%;
    height: 40px;
    color: #fff;
    background-color: #00AC64;
    border: none;
    border-radius: 4px;
    margin-top: 60px;
    margin-bottom: 15px;
    font-size: 20px;
    font-family: SOURCEHANSANSCN-REGULAR;
}

.cursor {
    font-size: 14px;
    color: #00AC64;
}

.title-content {
    color: #626262;
    font-size: 20px;
    font-family: SOURCEHANSANSCN-BOLD;
    line-height: 22px;
    margin-top: 15px;
    margin-bottom: 10px;
}
.login_input {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 35px;
    padding: 0 10px;
    margin-top: 20px;
    font-size: 40px;
}

.login_input input {
    border: none;
    color: #606266;
    height: 100%;
    font-size: 15px;
    margin: 0;
    padding: 0;
    padding-left: 10px;
    width: 250px;
    margin-right: 20px;
}

:deep .login_input {
    height: 50px;
    border: 2px solid #999999;
    border-radius: 7px;
}

.get-code {
    width: 40%;
    height: 30px;
    border-radius: 4px;
    // border: 1px solid #00AC64;
    background-color: #00AC64;
    text-align: center;
    line-height: 30px;
    color: #fff;
    border: none;
}
</style>
